export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: 'Back',
            backToProject: 'Back to home',
            editProjectName: 'Edit project name',
            folderUncategorized: 'Uncategorized',
            switchFolder: 'Switch folder',
            moveProjectConfirmTitle: 'Move project',
            moveProjectConfirmMessage: 'Move the current project to the selected folder?',
            moveProjectConfirmOk: 'Move',
            moveProjectConfirmCancel: 'Cancel',
            moveProjectSuccess: 'Project moved',
            moveProjectFailed: 'Failed to move project',
            switchProject: 'Switch project',
            recentProjects: 'Recent projects',
            noRecentProjects: 'No recent projects',
            browseAllProjects: 'Browse all projects',
            updateProjectNameSuccess: 'Project name updated successfully',
            updateProjectNameFailed: 'Failed to update project name',
            defaultTitle: 'Untitled Document',
            editTitle: 'Click to edit title',
            clickToEditName: 'Click to edit',
            screen: {
                single: 'Single Screen',
                split: 'Split Screen',
            },
            aiHiro: 'Hiro',
            save: 'Save',
            saveOptions: 'Save Options',
            saveToFolder: 'Save to Folder',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed',
            export: 'Export',
            share: 'Share',
            sharePermissionDenied: 'Only the project owner can share',
            readOnlyWarning: 'permission: You have read-only access',
            emptyContentError: 'Content is empty, cannot save',
            updateTitleSuccess: 'Title updated successfully',
            updateTitleFailed: 'Failed to update title',
            importing: 'Importing document...',
            importSuccess: 'Import successful',
            importFailed: 'Import failed',
            exportUpgradeTip: 'Export is available on paid plans. ',
            upgradeLink: 'Upgrade now',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: 'Add Source',
            createDocument: 'Create Document',
            selectDocumentType: 'Select document type and create',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: 'Blank',
            placeholder: 'Create a blank document',
            title: 'Blank Document',
            description: 'Create an empty document and start writing from scratch',
            action: 'Create Blank Document',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: 'Close Others',
            closeAll: 'Close All',
            files: 'Files',
            originalText: 'Original Text',
        },
    },
};
